// Maps a ProductPreviewSerializer hash to the props ProductButton expects.
// Mirrors how ProductPreview destructures `product` for ProductButton.
export default function iconButtonProps(product) {
  return {
    productId: product.id,
    name: product.name,
    sku: product.sku,
    price: parseFloat(product.price) || 0,
    discount: parseFloat(product.discount) || 0,
    productUrl: product.url,
    image: product.image,
    available: product.available,
    waitlistSubscribable: product.waitlistSubscribable,
    redirectionEnabled: product.redirectionEnabled,
    redirectText: product.redirectText,
    redirectLink: product.redirectLink,
    addToBagText: product.addToBagText,
    showAddToBag: product.showAddToBag,
    variant: product.variant,
  };
}
